import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import state from './tripTypes.state';
import getters from './tripTypes.getters';
import actions from './tripTypes.actions';
import mutations from './tripTypes.mutations';

BaseStore.registerModule('tripTypes', {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('tripTypes');

export {
	mapState,
	mapGetters,
	mapActions,
	mapMutations
};